<span [title]="title || ''" class="fill" inlineSVG="assets/icons/{{ name }}.svg"></span>
